<template>
    <div>
        <div class="contact-header">
            <h1 class="heading-text">Blacklist <span @click="addBlacklistBtn = true"><i class="glyphicon glyphicon-plus"></i> Add to blacklist</span></h1>
        </div>

        <div v-if="loadingblocklist == true" class="loading">
            <img src="~styles/img/load.gif" alt="">
        </div>

        <div v-if="loadingblocklist == false" class="contact-table table-responsive">
            <table class="table list-table spacing-table del-table">
                
                <tr
                v-for="allblocklist in blacklist"
                :key="allblocklist.id">
                    <td>{{allblocklist.number}}</td>
                    <td>
                        <a
                        :data-id="allblocklist.id"
                        @click="deleteoption()"
                        class="del-user el-icon-delete">
                        </a>
                    </td>
                </tr>
            </table>
        </div>

        <!-- dialogue for adding to blacklist -->
        <el-dialog title="Add to Blacklist" :visible.sync="addBlacklistBtn" width="50%">

            <form class="content-form">
                <div class="form-group">
                    <label for="">Number:</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="createBlacklist.number"
                    min="0"
                    autofocus>
                    <p class="text-danger">{{ addblacklisterror }}</p>
                </div>
            </form>

            <span slot="footer" class="dialog-footer" left>
                <el-button @click="addBlacklistBtn = false">Cancel</el-button>
                <el-button type="primary" @click="createBlacklistBtn()">Save</el-button>
            </span>

        </el-dialog>
    </div>
</template>


<script>
import axios from 'axios';
import {getblocklistnumbers, deleteblocklistnumber, setblocklistnumber, getHeader } from '../../../config';


export default {
    data() {
        return{
            loadingblocklist: true,
            addBlacklistBtn: false,
            activeid: "",
            addblacklisterror: "",

            blacklist: [{
                id: "",
                number: ""
            }],

            createBlacklist: [{
                number: ""
            }]
        }
    },

    methods: {
        refreshblocklist(){
            axios
            .get(getblocklistnumbers, {headers: getHeader()})
            .then(Response =>{
                // console.log(Response)
                if(Response.data.error = "false"){
                    this.blacklist = Response.data.data
                    this.$nextTick(function (){
                        this.loadingblocklist = false
                    })
                } else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'Something went wrong'
                    })
                }
            })
            .catch(function (error){
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Something went wrong'
                })
            });
        },

        deleteblocklist(){
            axios
            .post(deleteblocklistnumber, {id: this.activeid}, {headers:getHeader()})
            .then(Response =>{
                if(Response.data.error = "false"){
                    this.$nextTick(function (){
                        this.refreshblocklist()
                    })
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Number Successfully Deleted!'
                    })
                } else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'Something went wrong'
                    })
                }
            })
        },

        createBlacklistBtn() {
            if(!this.createBlacklist.number){
                this.addblacklisterror = "This field cant be empty"
            } else{
                axios
                .post(setblocklistnumber, {number: this.createBlacklist.number}, {headers: getHeader()})
                .then(Response =>{
                    console.log(Response)
                    if(Response.data.error = "false"){
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'Success',
                            text: 'Number Successfully Added.'
                        })
                        this.$nextTick(function (){
                            this.createBlacklist.number= ""
                            this.$nextTick(function (){
                                this.refreshblocklist()
                                this.$nextTick(function (){
                                    this.addBlacklistBtn = false
                                })
                            })
                        })
                    } else{
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Error',
                            text: 'Something went wrong'
                        })
                        this.$nextTick(function (){
                            this.createBlacklist.number= ""
                            this.$nextTick(function (){
                                this.addBlacklistBtn = false
                            })
                        })
                    }
                })
                .catch(() => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'Something went wrong'
                    })         
                });
            }
        },

        deleteoption: function() {
            this.activeid = event.target.dataset.id;

            this.$confirm('This will permanently delete number. Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
            })
            .then(() => {
               this.deleteblocklist()
            })
            .catch(() => {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Something went wrong'
                })         
            });
        }
    },

    mounted() {
        axios
        .get(getblocklistnumbers, {headers: getHeader()})
        .then(Response =>{
            // console.log(Response)
            if(Response.data.error = "false"){
                this.blacklist = Response.data.data
                this.$nextTick(function (){
                    this.loadingblocklist = false
                })
            } else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Something went wrong'
                })
            }
        })
        .catch(function (error){
            this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: 'Something went wrong'
            })
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/parts/blacklist.vue